enum fetchStatus {
    ERROR = "ERROR",
    IDLE = "IDLE",
    PENDING = "PENDING",
    REFETCHING = "REFETCHING",
    SUCCESS = "SUCCESS",
    STREAMING = "STREAMING",
    ABORTED = "ABORTED",
}

export default fetchStatus;
